module.exports = "https://static.wmbcdn.com/uniweb/images/155f4f88033157e99aed1c80e9de930c.svg";